import { render, staticRenderFns } from "./CaptchaFormItem.vue?vue&type=template&id=2fa91682&scoped=true&"
import script from "./CaptchaFormItem.vue?vue&type=script&lang=js&"
export * from "./CaptchaFormItem.vue?vue&type=script&lang=js&"
import style0 from "./CaptchaFormItem.vue?vue&type=style&index=0&id=2fa91682&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa91682",
  null
  
)

export default component.exports